import { AxiosResponse } from 'axios';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import { getLocaleMsg } from '../../lngProvider';
import { fetchPwaUserConfigSuccess, setUserConfigSuccess } from '../actions';

// function* fetchPWAUserConfigRequest() {
//     try {
//         const fetchedUserConfig = yield call(getPwaNeededUserConfig);

//         yield put(fetchPwaUserConfigSuccess(fetchedUserConfig.data));
//     } catch (error) {
//         return ShowError("", error);
//     }
// }

// export function* getPWAUserConfig() {
//     yield takeEvery(ActionTypes.GET_PWA_USER_CONFIG, fetchPWAUserConfigRequest);
// }

const getPwaNeededUserConfig = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get('userConfig/GetUserConfig');
};
const setPwaThemeUserConfig = async (param: any) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post(`userConfig/SetTheme`, param);
};

function* fetchPwaUserConfigRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedNews = yield call(getPwaNeededUserConfig);
    yield put(fetchPwaUserConfigSuccess(fetchedNews.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchPwaUserConfig() {
  yield takeEvery(ActionTypes.GET_PWA_USER_CONFIG, fetchPwaUserConfigRequest);
}

function* fetchSetUserConfig(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  const messages = getLocaleMsg();

  try {
    const fetchedsetPwaTheme = yield call(
      setPwaThemeUserConfig,
      action.payload,
    );
    yield put(setUserConfigSuccess(fetchedsetPwaTheme.data));
    // yield call(setPwaThemeUserConfig, action.payload);
    // yield put(setUserConfigSuccess());

    ShowSuccess(messages['messages.operationWasSuccessful'], '');
  } catch (error) {
    return ShowError('', error);
  }
}

export function* setUserConfig() {
  yield takeEvery(ActionTypes.SET_USER_CONFIG, fetchSetUserConfig);
}

export default function* rootSaga() {
  yield all([fork(fetchPwaUserConfig), fork(setUserConfig)]);
}
